import { navigate } from 'gatsby';

export default () => {
  if (window.location.pathname === '/') {
    const planSection = document.querySelector('#plansSection')
    window.scrollTo({
      behavior: 'smooth',
      left: 0,
      top: planSection.offsetTop - 15
    });
  } else {
    navigate('/nossos-planos/');
  }
}